<template>
  <article class="container">
    <div id="content" :class="{'has_actionbar' : !isVisible}" class="content">
      <v-runtime-template :template="promoTemplate"/>
    </div>
    <chatbot-wrapper v-if="chatbot === true"/>
    <a v-if="top === true" href="javascript:void(0)" class="btn_top" @click="scrollToTop"><span class="blind">TOP</span></a>
  </article>
</template>
<script>

import VRuntimeTemplate from 'v-runtime-template'
import { isEmpty, find } from 'lodash'
import MmpPromoCart from './MmpPromoCart'
import MmpPromoCartFloat from './MmpPromoCartFloat'
import MmpTimer from '@/components/_common/mmp-timer/MmpTimer'
import ChatbotWrapper from '@/components/pages/contents/chatbot/ChatbotWrapper.vue'

export default {
  name: 'PromotionDetail',
  metaInfo () {
    console.log('metaInfo chaged!!!')

    //     <!-- For Facebook -->
    // <meta property="og:title" content="" />
    // <meta property="og:type" content="article" />
    // <meta property="og:image" content="" />
    // <meta property="og:url" content="" />
    // <meta property="og:description" content="" />

    if (this.isNewDomain) {
      return {
        base: { href: this.baseCheck ? ('/' + this.promoInfo.virtualPath + '/') : '/' },
        meta: [
          { property: 'og:title', content: this.prdtNm },
          { property: 'og:type', content: 'website' },
          { property: 'og:url', content: window.location.href },
          { property: 'og:image', content: this.shareImageUrl },
          { property: 'og:description', content: this.prdtIntroCntnt },
          { property: 'og:site_name', content: window.location.href }
        ],
        title: '멀티캠퍼스 :: 상품정보 ::  ' + this.promoInfo.promoNm
        // script: [
        //   { src: '/static/swiper.min.js', async: true, defer: true }
        // ]
      }
    } else {
      return {
        base: { href: '/' + this.promoInfo.contextPath + '/' },
        meta: [
          { property: 'og:title', content: this.prdtNm },
          { property: 'og:type', content: 'website' },
          { property: 'og:url', content: window.location.href },
          { property: 'og:image', content: this.shareImageUrl },
          { property: 'og:description', content: this.prdtIntroCntnt },
          { property: 'og:site_name', content: window.location.href }
        ],
        title: '멀티캠퍼스 :: 상품정보 ::  ' + this.promoInfo.promoNm
        // script: [
        //   { src: '/static/swiper.min.js', async: true, defer: true }
        // ]
      }
    }
  },
  components: {
    VRuntimeTemplate,
    MmpPromoCart,
    MmpPromoCartFloat,
    MmpTimer,
    ChatbotWrapper
  },
  data () {
    return {
      promotionHtml: '',
      baseCheck: false,
      prdtNm: '',
      prdtIntroCntnt: '',
      swipers: [],
      eduGrpCd: '',
      corsCd: '',
      top: true, // top노출여부  (LCPLAN-10718:외국어포탈 개편)
      chatbot: false // 챗봇 노출여부 (LCPLAN-13041:MMP챗봇 개발)
    }
  },
  computed: {
    shareImageUrl () {
      let baseUrl = window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : ( ':' + window.location.port))

      return baseUrl + '/static/sns_share.png'
    },
    mmpServiceUrl () {
      return this.promoInfoStore.getters.getMmpUiBaseUrl
    },
    promoTemplate () {
      return this.promotionHtml
    },
    promoInfoStore () {
      return window.vue.getStore('promoInfo')
    },
    promoInfo () {
      return this.promoInfoStore.state.promoInfo
    },
    kakaoApiKey () {
      return this.promoInfoStore.state.promoInfo.kakaoCtfcKeyCntnt
    },
    fbApiKey () {
      return this.promoInfoStore.state.promoInfo.facbkCtfcKeyCntnt
    },
    fbVersion () {
      return 'v7.0'
    },
    isNewDomain () {
      return isEmpty(this.promoInfo.contextPath) && !isEmpty(this.promoInfo.virtualPath)
    },
    productList () {
      return this.promoInfoStore.state.productDetail.productList
    },
    selectedProductKey () {
      return this.promoInfoStore.state.productDetail.selectedProductKey
    },
    selectedProduct () {
      if (isEmpty(this.selectedProductKey)) {
        return {}
      }

      var splitArray = this.selectedProductKey.split('|@|')

      var selectKeyObj = {
        eduGrpCd: splitArray[0],
        corsCd: splitArray[1],
        corsYr: splitArray[2],
        corsDgrCd: splitArray[3]
      }

      var findObj = find(this.productList, selectKeyObj)

      return findObj
    },
    matchMedia () {
      const checkMedia = window.matchMedia('(max-width: 1099px)')
      return !!checkMedia.matches
    },
    // 챗봇 사이드바 관련 수정 (LCPLAN-13041:MMP챗봇 개발)
    isDesktop () {
      return this.$utils.userAgent.isDesktop()
    },
    // 챗봇 사이드바 관련 수정 (LCPLAN-13041:MMP챗봇 개발)
    isVisible () {
      if (this.isDesktop) {
        return this.promoInfoStore.state.productDetail.isVisible
      } else {
        return false
      }
    }
  },
  watch: {
    'promoTemplate': {
      handler: function (nVal, oVal) {
        console.log('promoTemplate changed !!')
      }
    },
    'eduGrpCd': {
      handler: function (nVal, oVal) {
        if (!isEmpty(this.eduGrpCd) && !isEmpty(this.corsCd) && nVal !== oVal) {
          this.getProductList()
        }
      }
    }
  },
  beforeUpdate () {
    this.baseCheck = true
  },
  updated () {
    console.log('updated !!')
    setTimeout(function () {
      this.baseCheck = false
    }.bind(this), 1500)
  },
  async created () {
    this.baseCheck = true
    this.getTemplate()

    if (!isEmpty(this.kakaoApiKey)) {
      let kakaoScriptUrl = '/static/kakao.js'
      await this.$loadScript(kakaoScriptUrl, 'Kakao', 2000, 10)

      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(this.kakaoApiKey)
      }
    }

    if (!isEmpty(this.fbApiKey)) {
      await this.initFacebook()
    }

    // window.addEventListener('beforeunload', this.preventNav)
  },
  methods: {
    // swiperUpdate () {
    //   this.destroySwiper()
    //   if (this.matchMedia) {
    //     this.swipers = this.createSwiper()
    //     console.log('createSwiper !!!!!', this.swipers)
    //   }
    // },
    //
    // destroySwiper () {
    //   for (var swiperObj; swiperObj; swiperObj = take(this.swipers)) {
    //     if (swiperObj) {
    //       console.log('destroySwiper !!!!!', swiperObj)
    //       swiperObj.destroy()
    //     }
    //   }
    // },
    // createSwiper () {
    //   return [].map.call(document.querySelectorAll('.swiper-container'), function (el) {
    //     return new Swiper(el, {
    //       slidesPerView: 'auto',
    //       spaceBetween: 20,
    //       pagination: {
    //         el: el.querySelector('.swiper-pagination')
    //       }
    //     })
    //   })
    // },
    initFacebook () {
      return new Promise(function (resolve) {
        window.fbAsyncInit = function () { // eslint-disable-line func-names
          var fbOptions = {
            appId: this.fbApiKey,
            xfbml: false,
            version: this.fbVersion,
            cookie: true
          }

          window.FB.init(fbOptions)

          window.FB.AppEvents.logPageView()
          resolve('SDK Loaded!')
        }.bind(this)

        var facebookScriptUrl = 'https://connect.facebook.net/en_US/sdk.js'
        this.$loadScript(facebookScriptUrl, 'FB', 2000, 10)
      }.bind(this))
    },
    getTemplate () {
      let resourceUrl = ''

      console.log('getTemplate !!!!!!!!!')

      if (this.isNewDomain) {
        resourceUrl = this.promoInfo.virtualPath + '/promoDetail/' + this.$route.params.subHtml.replace('.html', '.html.org')
      } else {
        resourceUrl = this.promoInfo.contextPath + '/promoDetail/' + this.$route.params.subHtml.replace('.html', '.html.org')
      }

      // top 노출여부(LCPLAN-10718:외국어포탈 개편)
      this.top = !(this.promoInfo.virtualPath === 'outloud')

      // 챗봇 노출여부 (LCPLAN-13041:MMP챗봇 개발)
      const chatbotShowPathList = ['multicampusmain', 'frontend', 'backend', 'hpefront', 'cloud', 'kdigital', 'kdigital3', 'kdigital4']
      if (chatbotShowPathList.indexOf(this.promoInfo.virtualPath) > -1) this.chatbot = true

      this.$http.loadRes(resourceUrl).then( (res) => {
      // window.vue.loadRes(promoStore.state.promoInfo.contextPath + '/index.org').then( (res) => {
        this.promotionHtml = res
      })
    },
    shareKakao () {
      window.Kakao.Link.sendDefault({
        objectType: 'text',
        text: this.prdtNm,
        link: {
          mobileWebUrl: window.location.href
        }
      })
      // window.Kakao.Link.sendScrap({
      //   requestUrl: window.location.href,
      //   installTalk: true
      // })
    },
    shareFacebook () {
      if (window.FB && window.FB.ui) {
        window.FB.ui({
          method: 'share',
          href: window.location.href,
          quote: this.prdtNm
        })
      } else {
        var facebookCallUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href)
        var windowOptions = {
          width: 600,
          height: 400,
          scrollbars: 'no'
        }
        this.$utils.common.openWindowPopup(facebookCallUrl, {}, undefined, windowOptions, false)
      }

      // https://www.facebook.com/sharer/sharer.php?u=
    },
    setProductInfo: function (eduGrpCd, corsCd) {
      if (isEmpty(eduGrpCd) || isEmpty(corsCd) ) {
        return
      }
      this.$set(this, 'corsCd', corsCd)
      this.$set(this, 'eduGrpCd', eduGrpCd)
    },
    getProductList: async function () {
      console.log('getProductList !!!!!!!!!')

      try {
        var params = {
          eduGrpCd: this.eduGrpCd,
          corsCd: this.corsCd,
          promoId: this.promoInfo.promoId
        }

        let viewPromoResult = await this.$http.busn.viewPromo(this, params)

        if (viewPromoResult.data.status === 'OK') {
          this.promoInfoStore.commit('SET_PRODUCT_LIST', viewPromoResult.data.data.resultData)
          this.promoInfoStore.commit('SET_PRODUCT_SELECTED', viewPromoResult.data.data.resultData[0].eduGrpCd + '|@|' + viewPromoResult.data.data.resultData[0].corsCd + '|@|' + viewPromoResult.data.data.resultData[0].corsYr + '|@|' + viewPromoResult.data.data.resultData[0].corsDgrCd)

          if (!isEmpty(viewPromoResult.data.data.prdtNm)) {
            this.$set(this, 'prdtNm', viewPromoResult.data.data.prdtNm)
          }
          if (!isEmpty(viewPromoResult.data.data.prdtIntroCntnt)) {
            this.$set(this, 'prdtIntroCntnt', viewPromoResult.data.data.prdtIntroCntnt)
          }
          // 정상적으로 상세 페이지 열리는 경우
          if (window.dataLayer) {
            window.dataLayer.push({ ecommerce: null })
            window.dataLayer.push({
              event: 'labbit_view_item',
              event_page: window.location.href,
              ecommerce: {
                value: 0,
                items: [{
                  item_name: viewPromoResult.data.data.prdtNm,
                  price: viewPromoResult.data.data.resultData[0].ucstSmtotAmt,
                  quantity: 1
                }]
              }
            })
          }
        } else {
          this.promoInfoStore.commit('SET_PRODUCT_LIST', [])
          this.promoInfoStore.commit('SET_PRODUCT_SELECTED', '')
          await this.$popup.alert(this.$el, {title: '알림', contents: '오픈 준비 중입니다.'})
        }
      } catch (err) {
        this.promoInfoStore.commit('SET_PRODUCT_LIST', [])
        this.promoInfoStore.commit('SET_PRODUCT_SELECTED', '')
        console.log(err)
        await this.$popup.alert(this.$el, {title: '알림', contents: '서비스 장애가 발생하였습니다.'})
      }
    },
    async addCart () {
      if (isEmpty(this.selectedProduct)) {
        return
      }

      if (this.selectedProduct.aplYn === 'N' || this.promoInfo.activeYn === 'N') {
        this.$popup.toast('프로모션 기간이 아닙니다.')
        // await this.$popup.alert(this.$el, { title: '알림', contents: '프로모션 기간이 아닙니다.' })
        return
      }

      var params = {
        eduGrpCd: this.selectedProduct.eduGrpCd,
        corsCd: this.selectedProduct.corsCd,
        corsYr: this.selectedProduct.corsYr,
        corsDgrCd: this.selectedProduct.corsDgrCd,
        prchsTyp: 'cart',
        busnCd: this.promoInfoStore.state.promoInfo.busnCd,
        promoId: this.promoInfoStore.state.promoInfo.promoId,
        promoNm: this.promoInfoStore.state.promoInfo.promoNm
      }

      try {
        let insertCartResult = await this.$http.busn.insertCart(this, params)

        if (insertCartResult.data.status === 'OK') {
          // await this.$popup.alert(this.$el, { title: '알림', contents: '과정이 장바구니에 담겼습니다.' })
          this.$popup.toast('과정이 장바구니에 담겼습니다.')
          window.vue.getStore('cartInfo').dispatch('updateCartCnt')

          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'Ecommerce_add',
              category: 'Ecommerce',
              action: 'Add',
              ecommerce: {
                add: {
                  products: [{
                    name: this.selectedProduct.corsNm,
                    id: this.selectedProduct.corsCd,
                    price: this.selectedProduct.ucstSmtotAmt,
                    variant: this.selectedProduct.eduStartDtm + ',' + this.selectedProduct.eduEndDtm,
                    quantity: 1
                  }]
                }
              }
            })
          }
          return
        }

        await this.$popup.alert(this.$el, { title: '알림', contents: insertCartResult.data.message })
      } catch (error) {
        console.log(error)
        await this.$popup.alert(this.$el, {title: '알림', contents: '서비스 장애가 발생하였습니다.'})
      }
    },
    async order () {
      // cartPrdtNo: "C723904943"
      // result: "ok"
      // totalCount: 1
      if (isEmpty(this.selectedProduct)) {
        return
      }

      if (this.selectedProduct.aplYn === 'N' || this.promoInfo.activeYn === 'N') {
        this.$popup.toast('프로모션 기간이 아닙니다.')
        // await this.$popup.alert(this.$el, { title: '알림', contents: '프로모션 기간이 아닙니다.' })
        return
      }

      var params = {
        eduGrpCd: this.selectedProduct.eduGrpCd,
        corsCd: this.selectedProduct.corsCd,
        corsYr: this.selectedProduct.corsYr,
        corsDgrCd: this.selectedProduct.corsDgrCd,
        prchsTyp: 'payment',
        busnCd: this.promoInfoStore.state.promoInfo.busnCd,
        promoId: this.promoInfoStore.state.promoInfo.promoId,
        promoNm: this.promoInfoStore.state.promoInfo.promoNm
      }

      try {
        let insertCartResult = await this.$http.busn.insertCart(this, params)

        if (insertCartResult.data.status === 'OK') {
          console.log(insertCartResult.data.data)
          if (insertCartResult.data.data.corsYn !== undefined && insertCartResult.data.data.corsYn === 'Y') {
            await this.$popup.alert(this.$el, {title: '알림', contents: '과정(' + insertCartResult.data.data.corsNm + ')와 학습기간이 겹쳐서 신청이 불가능합니다.'})
            return
            // [TO_DO]TOTALSR-52790 CF05 정부지원사업 과정의 경우 겹치게 학습기간 겹치게 신청 안되도로 체크로직 넣기
          } else {
            if (window.dataLayer) {
              window.dataLayer.push({ ecommerce: null })
              window.dataLayer.push({
                event: 'labbit_add_to_cart',
                event_page: window.location.href,
                ecommerce: {
                  value: 0,
                  items: [{
                    item_name: this.selectedProduct.corsNm,
                    price: this.selectedProduct.ucstSmtotAmt,
                    quantity: 1
                  }]
                }
              })
            }

            window.vue.getStore('cartInfo').dispatch('updateCartCnt')
            this.$goPage({name: 'PaymentOrder', query: { cartPrdtNos: insertCartResult.data.data.cartPrdtNo }})
            return
          }
        }

        await this.$popup.alert(this.$el, { title: '알림', contents: insertCartResult.data.message })
      } catch (error) {
        console.log(error)
        await this.$popup.alert(this.$el, {title: '알림', contents: '서비스 장애가 발생하였습니다.'})
      }
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    courseDetail (corsCd) {
      this.$goPage({name: 'CrsDetail', query: { corsCd: corsCd }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/promotion/PromotionDetail.vue